import { api } from './api'
import { Clinic, ClinicCreate, ClinicListItem, AuthTokens } from '../types'

export const clinicService = {
  createClinic: (data: ClinicCreate): Promise<Clinic> => {
    return api.post<Clinic>('/clinics', data)
  },

  getMyClinics: (): Promise<ClinicListItem[]> => {
    return api.get<ClinicListItem[]>('/clinics/me')
  },

  switchClinic: (clinicId: string): Promise<AuthTokens> => {
    return api.post<AuthTokens>('/auth/switch-clinic', { clinic_id: clinicId })
  },
}
